
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'AdvertisementBanner',
	data() {
		return {
			showBanner: true
		};
	},
	props: {
		text: {
			type: String,
			default: 'Advertisement'
		},
		endDate: {
			type: Boolean,
			default: false
		}
	}
});
